import React from "react";
import { HiArrowNarrowRight } from "react-icons/hi";
import { Link } from "react-scroll";

const Home = () => {
  return (
    <div name="home" className="w-full h-screen bg-[#0a192f]">
      {/* Container */}
      <div className="max-w-[1000px] mx-auto px-8 flex flex-col justify-center h-full">
        <p className="text-blue-400">My name is</p>
        <h1 className="text-4xl sm:text-7xl font-bold text-[#ccd6f6]">
          Ismail BASSAOUD
        </h1>
        <h2 className="text-4xl sm:text-5xl font-bold text-[#8892b0]">
          Fullstack Developer
        </h2>
        <p className="text-[#8892b0] py-4 max-w-[700px]">
          As a Fullstack Developer, I'm an ambitious and dedicated professional with a passion for building exceptional digital experiences. I recently graduated from BeWeb Ecole Régionale du Numérique and am excited to leverage my skills in both frontend and backend development to create dynamic and engaging applications.        
        </p>
        <div>
          <button className="text-white group border-2 px-6 py-3 my-2 flex items-center hover:bg-blue-600 hover:border-blue-600">
            <Link to="work" smooth={true} offset={-70} duration={500}>
              View Work
            </Link>
            <span className="group-hover:rotate-90 group-hover:mt-[-12px] duration-300">
              <HiArrowNarrowRight className="ml-3" />
            </span>
          </button>
        </div>
      </div>
    </div>
  );
};

export default Home;
